import surveyLoginPageImage from "../assets/images/survey_login.png";
import SurveyDashboardImage from "../assets/images/survey dashboard.png";
import CreateSurveyImage from "../assets/images/create survey.png";

import CollegeLoginImage from "../assets/images/college_login.png";
import collegeAddStaff from "../assets/images/add staff.png";
import CollegeFinancialReport from "../assets/images/finacial report of college.png";
import ERP from "../assets/images/erp.png";
import lotteryImage from "../assets/images/946da769-6a24-4a3d-b91e-606d9e8dfd90.png";
import ERPImage from "../assets/images/8214f2f0-63f1-4172-84ad-30922ba18ee1.png";
import MerchantAppImage from "../assets/images/36001696-1230-4f1b-8b60-e3cd16ba5eae.png";
import MobileAppImage from "../assets/images/d141f4f3-1337-47f8-ae2a-5d17227c1ded.png";
import ShareAppImage from "../assets/images/a400d931-c864-426d-8ce1-24925af002b5.png";
import MerchantPortalImage from "../assets/images/85016214-619b-424d-8e90-9fec40b326e1.png";
import MobileWebPortal from "../assets/images/0ffabe2f-ea1c-4051-80cb-c1921b05e5fa.png";
import UIDesignImage from "../assets/images/meku_portfolio.png";
import AppreciateImage from "../assets/images/cio_certificate.png";
import CourseImage from "../assets/images/47193cda-1793-4981-a0ce-eff53b220699.png";
import RecomendationImage from "../assets/images/af39aa0f-0574-4937-9d8d-4c9ac5864186.png";
import CertificateCEO from "../assets/images/ceo_certificate.png";
import FigmaCertificate from "../assets/images/figma_certificate.jpg";
import NodeCertificate from "../assets/images/Node_Certificate.jpg";
import AccountScreenImage from "../assets/images/acct_screen.png";
import MobileStartImage from "../assets/images/mobile_start.png";
import MerchantQRImage from "../assets/images/qr.png";
import MerchantIntroImage from "../assets/images/Intro.png";
import MerchatProductImage from "../assets/images/list of products.png";
import ShareLoginPageImage from "../assets/images/share_login.png";
import ShareFirstImage from "../assets/images/share_first.png";
import AllDayImage from "../assets/images/allDay.png";
import Ecom1Image from "../assets/images/ecom1.png";
import Ecom2Image from "../assets/images/ecom2.png";
import SafariMobile1Image from "../assets/images/safari_mobile1.png";
import SafariMobile2Image from "../assets/images/safari_mobile2.png";
import SafariMobile3Image from "../assets/images/safari_mobile3.png";
import SafariPwa1Image from "../assets/images/safari_pwa1.png";
import SafariPwa2Image from "../assets/images/safar_pwa2.png";
import SafariPwa3Image from "../assets/images/safari_pwa3.png";
import SafariBotImage from "../assets/images/safari_bot.png";
import SafariPortal1Image from "../assets/images/safari_portal1.png";
import SafariPortal2Image from "../assets/images/safari_portal2.png";

export const IMAGES = {
  surveyLoginPageImage,
  SurveyDashboardImage,
  CreateSurveyImage,
  CollegeLoginImage,
  CollegeFinancialReport,
  collegeAddStaff,
  lotteryImage,
  ERPImage,
  MerchantAppImage,
  MobileAppImage,
  ShareAppImage,
  MerchantPortalImage,
  MobileWebPortal,
  UIDesignImage,
  AppreciateImage,
  CourseImage,
  ERP,
  RecomendationImage,
  CertificateCEO,
  FigmaCertificate,
  NodeCertificate,
  MobileStartImage,
  AccountScreenImage,
  MerchantIntroImage,
  MerchantQRImage,
  MerchatProductImage,
  ShareLoginPageImage,
  ShareFirstImage,
  AllDayImage,
  Ecom1Image,
  Ecom2Image,
  SafariMobile1Image,
  SafariMobile2Image,
  SafariMobile3Image,
  SafariPwa1Image,
  SafariPwa2Image,
  SafariPwa3Image,
  SafariBotImage,
  SafariPortal1Image,
  SafariPortal2Image,
};
